import type { BatchScale } from "@/lib/recipes/staged-method";
import type { CookingSession } from "@/types/cooking-session";
import { RecipeCard } from "./RecipeCard";

interface GridViewProps {
  sessions: CookingSession[];
  secondsOf: (session: CookingSession) => number;
  scaleOf: (id: number) => BatchScale;
  onExpand: (id: number) => void;
  onError: (message: string) => void;
}

/**
 * The Grid (YC-25): every recipe as a card, side by side. A card is never
 * narrower than a sixth of the row, so up to six share the width and the row
 * scrolls sideways past that.
 */
export function GridView({ sessions, secondsOf, scaleOf, onExpand, onError }: GridViewProps) {
  return (
    <div
      data-testid="grid-view"
      className="grid h-full min-h-0 auto-cols-[minmax(max(16rem,calc((100%_-_5rem)/6)),1fr)] grid-flow-col gap-4 overflow-x-auto pb-2"
    >
      {sessions.map((session) => (
        <RecipeCard
          key={session.id}
          session={session}
          seconds={secondsOf(session)}
          scale={scaleOf(session.id)}
          onExpand={() => onExpand(session.id)}
          onError={onError}
        />
      ))}
    </div>
  );
}
